import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';

const state: UserState = {
  adminUser: {
    group_ids: [],
    all_main_keys: [],
  },
  normalGroups: [],
  businessGroups: [],
};

const getters: GetterTree<UserState, RootState> = {};

const actions: ActionTree<UserState, RootState> = {
  fetchList(context, options) {
    return http.v1.user.fetchList(options).then(({ data }) => {
      const payload = data;
      const items = payload.data.data;
      return {
        items,
        total: payload.data.total,
      };
    });
  },
  fetch({ commit }, { id }) {
    return http.v1.user.fetch(id).then((response) => {
      commit('SET_ADMIN_USER', response.data.data);
    });
  },
  groups({ commit }) {
    return http.v1.user.groups().then((response) => {
      commit('SET_GROUPS', response.data.data);
    });
  },
  update({ commit }, { id, payload }) {
    return http.v1.user.update(id, payload).then((response) => {
      commit('SET_ADMIN_USER', response.data.data);
    });
  },
  changePassword(_, { id, payload }) {
    return http.v1.user.changePassword(id, payload);
  },
  impersonate({ dispatch }, { id }) {
    return http.v1.user.impersonate(id).then(async (response) => {
      dispatch('Auth/impersonateUser', response.data.data, { root: true });
    });
  },
  fetchBusinessList(_, { id, params }) {
    return http.v1.user.fetchBusinessList(id, { params });
  },
  activate({ commit }, { id }) {
    return http.v1.user.activate(id).then((response) => {
      commit('SET_ADMIN_USER', response.data.data);
    });
  },
  key(_, { id, payload }) {
    return http.v1.user.key(id, payload);
  },
  deleteBusiness(_, { id, business_oid }) {
    return http.v1.user.deleteBusiness(id, business_oid);
  },
  updateBusiness(_, { id, business_oid, group_id }) {
    return http.v1.user.updateBusiness(id, business_oid, {
      group_id: group_id,
    });
  },
};

const mutations: MutationTree<UserState> = {
  SET_ADMIN_USER(state, user) {
    state.adminUser = user;
  },
  SET_GROUPS(state, groups) {
    state.normalGroups = groups.normal_group;
    state.businessGroups = groups.business_group;
  },
};

const user: Module<UserState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default user;
